function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEuro = function SvgEuro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5A6.539 6.539 0 0 1 6.2 12H12v-2H5.6a3.4 3.4 0 0 1-.1-1 3.4 3.4 0 0 1 .1-1H12V6H6.2A6.539 6.539 0 0 1 12 2.5a6.259 6.259 0 0 1 4.2 1.6L18 2.3A9.005 9.005 0 0 0 3.5 6H0v2h3.1A3.4 3.4 0 0 0 3 9a3.4 3.4 0 0 0 .1 1H0v2h3.5a9 9 0 0 0 8.5 6 9.125 9.125 0 0 0 6-2.3l-1.8-1.8a6.259 6.259 0 0 1-4.2 1.6Z",
    style: {
      fill: "#b4b4b4"
    }
  }));
};
export default SvgEuro;